module.exports = __webpack_public_path__ + "static/esprit-44825cf2cea86c07fdfb098ab5150033.png";